module.exports = __webpack_public_path__ + "img/icon_loans.dd791035.2deae2c4.svg";